module.exports = __webpack_public_path__ + "img/loading-text.a582f372.gif";